import React from "react";
import { reduxForm } from "redux-form";
import cs from "classnames";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import format from "date-fns/format";

// import {form2query, query2form} from '../../misc/search';
import LocationInput2 from "~/components/common/LocationInput2";
import LabeledInput from "~/components/common/LabeledInput";
import DoubleSizeSelect from "~/components/common/DoubleSizeSelect";
import CalendarInput from "~/components/common/CalendarInput";
import EquipSelect from "~/components/common/EquipSelect";
import { MenuList, MenuListItem } from "~/components/common/MenuList";
import DropDown from "~/components/common/DropDown";
import { modalChange } from "~/modules/modal/actions";
import * as modes from "~/modules/modal/modes";
import mapDispatch from "~/misc/mapDispatch";
import { fallbackToArray } from "~/misc/search";
import * as equipment from "~/misc/equipment";
import config from "~/config";
import { isPastDay } from "~/misc/dates";
import { track } from "~/misc/metrics";
import Prompt from "../Prompt";
import {
  changShowCardAction,
  createPostTuckAction,
  addPostTruckAction,
  updatePostTruckAction,
  editPostTruckAction,
  setRateAction,
  ininFormAction,
} from "../../state/action";
import * as utils from "../../utils";

import checkbox from "../../../../../assets/posttruck/checkbox.svg";
import checkSelected from "../../../../../assets/posttruck/checkbox-select.svg";
import descriptionImg from "../../../../../assets/posttruck/description.svg";

import addCss from "./style.css";
import css from "./style.css";

const initForm = (data) => {
  if (!data) data = JSON.parse(JSON.stringify(utils.FORMDATA));
  const LOADSIZE = data.loadSize
    ? utils.LOADSIZESHOW[data.loadSize.toLowerCase()]
    : "FTL";
  const trailerType = data.trailerType || [
      equipment.humanLowerCaseToId[data.equipment],
    ] || ["F"];
  let result = {
    ...data,
    loadSize: LOADSIZE,
    trailerType: trailerType,
  };
  return result;
};

const postDataTemplate = {
  // createdAt: "",
  desiredRate: 0,
  dropoff: {
    address: "",
    city: "",
    deadhead: 0,
    lat: 0,
    lng: 0,
    state: "",
  },
  equipment: "",
  // id: null,
  length: 0,
  lengthAllowNull: true,
  loadSize: "",
  pickup: {
    address: "",
    city: "",
    deadhead: 0,
    lat: 0,
    lng: 0,
    state: "",
  },
  recurring: {
    dates: [],
    type: "",
  },
  // updatedAt: "",
  userId: 0,
  weightAllowNull: true,
  weightMax: 0,
  weightMin: 0,
};

const dropFunc = {
  weight: null,
  weekly: null,
  monthly: null,
};

class detailForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formError: Object.assign({}, utils.FROMERROR),
      ...JSON.parse(JSON.stringify(utils.FORMDATA)),
      frequencyError: {
        from: "",
        to: "",
        weekly: "",
        monthly: "",
      },
      isAgree: false,
      showWeightDrop: false,
      weightDrop: false,
      weeklyDrop: false,
      monthlyDrop: false,
      showPrompt: false,
    };
    this.address = {
      origin: null,
      destination: null,
    };

    const _this = this;

    dropFunc.weight = () => this.toggleDrop("weight", _this);
    dropFunc.weekly = () => this.toggleDrop("weekly", _this);
    dropFunc.monthly = () => this.toggleDrop("monthly", _this);

    this.togglePrompt = this.togglePrompt.bind(this);
  }
  componentDidMount() {
    const initData = this.props.initData;
    this.props.initForm(initData);
    if (!initData) {
      const newState = JSON.parse(JSON.stringify(utils.FORMDATA));
      this.props.setRate("");
      this.setState(newState);
      return;
    }
    const nowState = this.state;
    for (let key in nowState) {
      if (initData[key]) {
        nowState[key] = initData[key];
      }
    }
    nowState.destination = initData.dropoff.address;
    nowState.desDeadHead = initData.dropoff.deadhead;
    nowState.frequency = utils.FREQUENCY[initData.recurring.type];
    nowState.frequencyDate = Object.assign({}, utils.FORMDATA.frequencyDate);
    nowState.frequencyDate[nowState.frequency] = [...initData.recurring.dates];
    if (nowState.frequency === "One Time") {
      nowState.frequencyDate[nowState.frequency] = {
        from: [new Date(initData.recurring.dates[0])],
        to: [new Date(initData.recurring.dates[1])],
      };
    }
    if (nowState.frequency === "Recurring Weekly") {
      nowState.frequencyDate[nowState.frequency] = [
        ...initData.recurring.dates.map((item) => utils.WEEKLYPOSTDATA[item]),
      ];
    }
    nowState.orgDeadHead = initData.pickup.deadhead;
    nowState.origin = initData.pickup.address;
    nowState.rate = initData.desiredRate;
    this.setState(nowState);

    this.address.origin = { placeValue: initData.pickup };
    this.address.destination = { placeValue: initData.dropoff };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.rate !== this.state.rate) {
      this.setState({ rate: nextProps.rate });
    }
  }
  componentWillUnmount() {
    for (let key in dropFunc) {
      dropFunc[key] && document.removeEventListener("click", dropFunc[key]);
    }
  }
  render() {
    let props = this.props;

    const { formError } = this.state;

    const getDropdownItems = ({
      list,
      itemFunc,
      type,
      multi,
      selectedFunc,
    }) => {
      list = !Array.isArray(list) || !list ? [] : list;
      const isMulti = !!multi;
      return (
        <div className={cs(css.simpleDropdown)}>
          <MenuList multi={isMulti}>
            {list.map((item, i) => {
              const selected = selectedFunc ? selectedFunc(type, item) : false;
              return (
                <MenuListItem
                  fn={(e) => itemFunc.call(this, type, item, e)}
                  data-qa={`data-qa-${type}`}
                  title={item}
                  selected={selected}
                  key={i + item}
                  value={item}
                  values={list}
                />
              );
            })}
          </MenuList>
        </div>
      );
    };

    const SimpleDropdown = ({
      list,
      selected,
      itemFunc,
      type,
      tags,
      multi,
      selectedFunc,
      children,
    }) => {
      return (
        <DropDown
          data-qa={`data-qa-${type}`}
          id={type}
          wrapClassName={css.simpleDropdown}
          allowKeyboard={true}
          trigger={
            <LabeledInput
              data-qa={"data-qa-input"}
              label={utils.SHOWLABEL[type]}
              mediumInput
              value={selected}
              icon="plus"
              tags={!!tags}
              readOnly={true}
              touched={true}
              error={this.state.formError[type]}
            />
          }
          content={children({ list, itemFunc, type, multi, selectedFunc })}
          // onKeyPress={this.onKeyPress}
        />
      );
    };

    const OneTime = () => {
      return (
        <div className={css.frequencyOneTime}>
          <div className={css.onetimeDate}>
            <CalendarInput
              input={{ placeholder: "Available From" }}
              value={this.state.frequencyDate["One Time"].from}
              onChange={(e) =>
                this.frequencyOneTimeChange.call(this, "from", e)
              }
              initialValue={[new Date()]}
              data-qa="onetimeDate"
              label="Available From"
              multiSelect={true}
              wrapClassName={css.datePicker}
              dropDownId="onetimeDateFrom"
              disabledDays={(day) => this.dateDisable.call(this, day, "from")}
            />
            <div className={css.ptFormError}>
              {this.state.frequencyError.from}
            </div>
          </div>
          <div className={css.onetimeDate}>
            <CalendarInput
              input={{ placeholder: "Available From" }}
              value={this.state.frequencyDate["One Time"].to}
              onChange={(e) => this.frequencyOneTimeChange.call(this, "to", e)}
              initialValue={[new Date()]}
              data-qa="onetimeDate"
              label="Available To"
              multiSelect={true}
              wrapClassName={css.datePicker}
              dropDownId="onetimeDateTo"
              disabledDays={(day) => this.dateDisable.call(this, day, "to")}
            />
            <div className={css.ptFormError}>
              {this.state.frequencyError.to}
            </div>
          </div>
        </div>
      );
    };

    const Daily = () => {
      return (
        <div className={css.frequencyDaily}>
          <p className={css.description}>
            <span className={css.descriptionIcon}>{descriptionImg()}</span>
            <span className={css.descriptionText}>
              Please note: You are posting this lane as a Daily recurring lane.
            </span>
          </p>
        </div>
      );
    };

    const Weekly = () => {
      return (
        <div className={css.frequencyWeekly}>
          <div
            className={css.frequencyWeeklyShow}
            onClick={() => this.toggleDrop.call(this, "weekly")}
          >
            <div className={css.showSelected}>
              {this.state.frequencyDate["Recurring Weekly"].join(",")}
            </div>
            <span className={css.plusIcon}></span>
          </div>
          <div className={css.ptFormError}>
            {this.state.frequencyError.weekly}
          </div>
          {this.state.weeklyDrop && (
            <div
              className={css.frequencyWeeklyPanel}
              onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
              }}
            >
              {utils.WEEKLYTYPES.map((item) => {
                const isSelected =
                  this.state.frequencyDate["Recurring Weekly"].includes(item);
                return (
                  <div
                    className={cs(css.frequencyDateItem, {
                      [css.frequencyDateItemSelected]: isSelected,
                    })}
                    key={item}
                    onClick={() =>
                      this.multiDateSelect("Recurring Weekly", item)
                    }
                  >
                    {isSelected ? checkSelected() : checkbox()}
                    <span>{item}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    };

    const Monthly = () => {
      return (
        <div className={css.frequencyMonthly}>
          <div
            className={css.frequencyMonthlyShow}
            onClick={() => this.toggleDrop.call(this, "monthly")}
          >
            <div className={css.showSelected}>
              {this.state.frequencyDate["Recurring Monthly"].join(",")}
            </div>
            <span className={css.plusIcon}></span>
          </div>
          <div className={css.ptFormError}>
            {this.state.frequencyError.monthly}
          </div>
          {this.state.monthlyDrop && (
            <div
              className={css.frequencyMonthlyPanel}
              onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
              }}
            >
              {utils.MONTHLYTYPES.map((item) => {
                const isSelected =
                  this.state.frequencyDate["Recurring Monthly"].includes(item);
                return (
                  <div
                    className={cs(css.frequencyDateItem, {
                      [css.frequencyDateItemSelected]: isSelected,
                    })}
                    key={item}
                    onClick={() =>
                      this.multiDateSelect("Recurring Monthly", item)
                    }
                  >
                    <span>{item}</span>
                  </div>
                );
              })}
              {Array(31)
                .fill("1")
                .map((item, index) => (
                  <div
                    className={css.monthlyItemEmpty}
                    key={item + index}
                  ></div>
                ))}
            </div>
          )}
        </div>
      );
    };

    const desStr =
      "Rate cannot be calculated, please enter pickup & dropoff location so we can calculate the rate upon the total price you have entered.";

    return (
      <section className={css.ptDetail}>
        {this.state.showPrompt && (
          <Prompt
            type="error"
            showClose={true}
            showIcon={true}
            description={desStr}
            close={this.togglePrompt}
          />
        )}
        <form data-qa="alert-form" noValidate>
          <div className={css.ptDeTailForm}>
            <div className={css.formRow}>
              <div className={css.address}>
                <LocationInput2
                  {...props.fields.origin}
                  id="origin"
                  data-qa="origin"
                  name="origin"
                  label="Origin"
                  inputClassName="pt-origin-input"
                  placeholder="Enter City"
                  onBlur={(param) => this.addressBlur(param, "origin")}
                  autoComplete="off"
                  touched={true}
                  error={formError.origin}
                />
                <LabeledInput
                  {...props.fields.orgDeadHead}
                  id="orgDeadHead"
                  label="Deadhead.mi"
                  type="number"
                  data-qa="dhd-field"
                  value={this.state.orgDeadHead}
                  onChange={(param) =>
                    this.numberInputChange("orgDeadHead", param)
                  }
                  onFocus={(param) =>
                    this.numberInputChange("orgDeadHead", param)
                  }
                  onBlur={(param) => this.numberInputBlur("orgDeadHead", param)}
                />
              </div>
              <div className={css.address}>
                <LocationInput2
                  {...props.fields.destination}
                  id="destination"
                  data-qa="destination"
                  label="Destination"
                  inputClassName="pt-destination-input"
                  placeholder="Enter City"
                  onBlur={(param) => this.addressBlur(param, "destination")}
                  autoComplete="off"
                  touched={true}
                  error={formError.destination}
                />
                <LabeledInput
                  {...props.fields.desDeadHead}
                  id="desDeadHead"
                  label="Deadhead.mi"
                  type="number"
                  data-qa="dhd-field"
                  value={this.state.desDeadHead}
                  onChange={(param) =>
                    this.numberInputChange("desDeadHead", param)
                  }
                  onFocus={(param) =>
                    this.numberInputChange("desDeadHead", param)
                  }
                  onBlur={(param) => this.numberInputBlur("desDeadHead", param)}
                />
              </div>
            </div>
            <div className={css.formRow}>
              <div className={css.equipmentInfoGroup}>
                <div className={css.equipmentInfo}>
                  <EquipSelect
                    {...props.fields.trailerType}
                    limit={1}
                    label="Trailer Type"
                    withoutAny
                    dropDownId="postTruckTrailerType"
                    data-qa="postTruckTrailerType"
                  />
                  <div className={css.ptFormError}>
                    {this.state.formError["trailerType"]}
                  </div>
                </div>
                <div className={css.equipmentInfo}>
                  <DoubleSizeSelect
                    {...props.fields.loadSize}
                    wrapClassName={addCss.miniInput}
                    dropDownId="loadsizeSelect"
                  />
                </div>
              </div>
              <div className={css.equipmentInfoGroup}>
                <div className={css.equipmentInfo}>
                  <LabeledInput
                    data-qa={"data-qa-input"}
                    label={utils.SHOWLABEL["length"]}
                    mediumInput
                    value={this.state.length}
                    readOnly={false}
                    onChange={(param) => this.numberInputChange("length", param)}
                    onBlur={(param) =>
                      this.numberInputBlur("length", param, true)
                    }
                    onFocus={(param) => this.numberInputChange("length", param)}
                    touched={true}
                    error={formError.length}
                  />
                </div>
                <div className={cs(css.equipmentInfo, css.weightInput)}>
                  <label>{utils.SHOWLABEL["weight"]}</label>
                  <div
                    className={cs(css.weightInputShowInfo, {
                      [css.weightInputActive]: this.state.showWeightDrop,
                    })}
                    onClick={(e) => this.toggleDrop.call(this, "weight")}
                  >
                    <span>{this.state.weight}</span>
                    <span className={css.plusIcon}></span>
                  </div>
                  {this.state.weightDrop && (
                    <div className={css.weightDropdownPanel}>
                      <div
                        className={css.weightInputContainer}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.nativeEvent.stopImmediatePropagation();
                        }}
                      >
                        <input
                          type="text"
                          value={this.state.weightInput}
                          onChange={(param) =>
                            this.numberInputChange("weightInput", param)
                          }
                          onBlur={(param) => this.weightInputBlur(param)}
                        />
                      </div>
                      {utils.WEIGHTTYPES.map((item) => (
                        <div
                          className={css.weightDropdownItem}
                          key={item}
                          onClick={() => this.weightItemSelect(item)}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={css.formRow}>
              <div className={css.rateInput}>
                <div className={css.labelBlock}>
                  <label>{utils.SHOWLABEL["rate"]}</label>
                </div>
                <div
                  className={css.inputBlock}
                  onClick={() => this.openRateModal()}
                >
                  <span>$</span>
                  <input
                    className={css.commonInput}
                    type="text"
                    // onChange={(e) => this.rateInputChane(e)}
                    // onBlur={() => this.rateInputBlur()}
                    value={this.state.rate}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>
            <div className={css.formRow}>
              <div className={css.frequencyItem}>
                <SimpleDropdown
                  list={utils.FREQUENCYPES}
                  selected={this.state.frequency}
                  itemFunc={this.simpleDropdownFunc}
                  type="frequency"
                  children={getDropdownItems}
                />
              </div>
              {this.state.frequency === "One Time" && <OneTime />}
              {this.state.frequency === "Recurring Daily" && <Daily />}
              {this.state.frequency === "Recurring Weekly" && <Weekly />}
              {this.state.frequency === "Recurring Monthly" && <Monthly />}
            </div>
          </div>
          <div className={css.ptDetailAuthRow}>
            <div className={css.authCheck}>
              <span
                className={css.authCheckClick}
                onClick={() => {
                  this.setState({ isAgree: !this.state.isAgree });
                }}
              >
                <div className={css.checkbox}>
                  {this.state.isAgree ? checkSelected() : checkbox()}
                </div>
                <span>By using this feature you agree to our </span>
              </span>
            </div>
            <p className={css.authDetails}>
              <a
                target="_blank"
                href="https://truckerpath.com/terms-of-service"
              >
                Terms of service
              </a>
              and
              <a target="_blank" href="https://truckerpath.com/privacy-policy">
                Privacy Policy
              </a>
            </p>
          </div>
        </form>
        <div className={css.ptDetailBtnRow}>
          <button
            className={cs(css.ptDetailBtn, css.ptCancelBtn)}
            onClick={() => this.backToList()}
          >
            Cancel
          </button>
          <button
            className={cs(css.ptDetailBtn, {
              [css.ptDetailBtnDisable]: !this.state.isAgree,
            })}
            onClick={() => this.postNewTruck()}
          >
            {this.props.showCard.toLowerCase().includes("edit")
              ? "Save"
              : "Post"}
          </button>
        </div>
      </section>
    );
  }
  backToList() {
    const { cancelAction } = this.props;
    track("Post Truck Actions", {
      Action: "Cancel"
    })
    cancelAction();
  }
  checkPostData() {
    let flag = true;
    for (const key in this.state.formError) {
      if (key === "frequency") {
        flag = this.frequencyCheck() && flag;
        continue;
      }
      let val = this.state[key];
      if (key === "origin" || key === "destination") {
        !val && this.checkRequire(key, val);
        flag = val && !this.state.formError[key] && flag;
        continue;
      }
      if (key === "trailerType") {
        val = this.props.fields.trailerType.value[0];
      }
      if (key === "length") {
        flag = flag & this.lengthCheck();
        continue;
      }
      flag = flag & !!val;
      this.checkRequire(key, val);
    }
    return flag;
  }

  lengthCheck = () => {
    const length = this.state.length;
    if(Number(length) > 99 || Number(length) < 0) {
      this.state.formError.length = "Length is over limit.";
      this.setState({
        formError: this.state.formError
      })
      return false;
    }
    return true;
  }

  frequencyCheck() {
    const ftype = this.state.frequency;
    const fval = this.state.frequencyDate[ftype];
    let reVal = true;
    switch (this.state.frequency) {
      case "One Time":
        reVal = !!fval.from.length > 0 && !!fval.to.length > 0;
        fval.from.length == 0 &&
          this.frequencyError("from", !!fval.from.length > 0);
        fval.to.length == 0 && this.frequencyError("to", !!fval.to.length > 0);
        break;
      case "Recurring Weekly":
        reVal = !!fval.length > 0;
        this.frequencyError("weekly", reVal);
        break;
      case "Recurring Monthly":
        reVal = !!fval.length > 0;
        this.frequencyError("monthly", reVal);
        break;
      default:
        break;
    }
    this.checkRequire("frequency", reVal);
    return reVal;
  }
  dateDisable(day, type) {
    const nowDate = new Date();
    // six month later
    const isSixMonthLater = this.sixMothLater(day, nowDate);
    // is past dy
    const isPast = isPastDay(day, nowDate);
    let isLater = false;

    // deprecate
    // if (type === "from" && this.state.frequencyDate["One Time"].to) {
    //   isLater =
    //     new Date(day) > new Date(this.state.frequencyDate["One Time"].to);
    // }
    // if (type === "to" && this.state.frequencyDate["One Time"].from) {
    //   isLater =
    //     new Date(day) < new Date(this.state.frequencyDate["One Time"].from);
    // }
    return isSixMonthLater || isPast || isLater;
  }
  sixMothLater(day, nd) {
    const nowDate = {
      year: nd.getFullYear(),
      month: nd.getMonth(),
      date: nd.getDate(),
    };
    return (
      new Date(day) > new Date(nowDate.year, nowDate.month + 6, nowDate.date)
    );
  }
  frequencyError(type, val) {
    const nowError = this.state.frequencyError;
    nowError[type] = val
      ? ""
      : type === "from" || type === "to"
      ? `${type} is required`
      : "Please select at least one option";
    this.setState({ frequencyError: nowError });
  }
  postNewTruck() {
    if (!this.state.isAgree || !this.checkPostData()) return;
    const pickup = this.address.origin.placeValue;
    const dropoff = this.address.destination.placeValue;
    const datas = {
      fix_date: [
        format(this.state.frequencyDate["One Time"].from, "MMM DD,YYYY"),
        format(this.state.frequencyDate["One Time"].to, "MMM DD,YYYY"),
      ],
      every_day: [],
      every_week: [
        ...this.state.frequencyDate["Recurring Weekly"].map(
          (item) => utils.WEEKLYPOSTDATA[item]
        ),
      ],
      every_month: [...this.state.frequencyDate["Recurring Monthly"]],
    };

    const weightData = this.state.weightInput
      ? {
          weightMax: this.state.weightInput,
          weightMin: "0",
        }
      : utils.WEIGHTPOSTDATA[this.state.weight];

    const postData = Object.assign({}, postDataTemplate);

    postData.desiredRate = this.state.rate ? this.state.rate : "0";
    postData.dropoff = {
      address: dropoff.name || dropoff.address,
      city: dropoff.city,
      deadhead: this.state.desDeadHead ? parseInt(this.state.desDeadHead) : 0,
      lat: dropoff.lat,
      lng: dropoff.lng,
      state: dropoff.state,
    };

    postData.equipment = fallbackToArray(
      this.props.fields.trailerType.value[0]
    ).map((i) => equipment.idToHumanLowerCase[i])[0];

    if (
      this.props.initData &&
      this.props.initData.id &&
      this.props.showCard === utils.POSTTRUCKSHOWTYPE.DETAIL_EDIT
    ) {
      postData.id = this.props.initData.id;
    }
    postData.length = this.state.length ? parseInt(this.state.length) : 0;
    postData.loadSize =
      utils.LOADSIZEPOSTDATA[
        this.props.fields.loadSize.value || this.state.loadSize
      ];
    postData.pickup = {
      address: pickup.name || pickup.address,
      city: pickup.city,
      deadhead: this.state.orgDeadHead ? parseInt(this.state.orgDeadHead) : 0,
      lat: pickup.lat,
      lng: pickup.lng,
      state: pickup.state,
    };
    postData.recurring = {
      dates: datas[utils.FREQUENCY[this.state.frequency]],
      type: utils.FREQUENCY[this.state.frequency],
    };
    postData.userId = this.props.userId;
    postData.weightMax = weightData.weightMax;
    postData.weightMin = weightData.weightMin;
    track("Post Truck Actions", {
      Action: "Post",
    })
    switch (this.props.showCard) {
      case utils.POSTTRUCKSHOWTYPE.DETAIL_CREATE:
      case utils.POSTTRUCKSHOWTYPE.DETAIL_COPY:
      case utils.POSTTRUCKSHOWTYPE.DETAIL_LOADALERT:
        this.props.createPostTruck(postData).then((res) => {
          if (!res){
            return track("Post Truck Results", {
              outcome: "Failed to submit",
            })
          } 
          track("Post Truck Results", {
            outcome: "Submitted",
            postTruckId: res.data.id
          })
          console.log(res.data);
          this.props.addData(res.data);
          this.props.changeShowCard(utils.POSTTRUCKSHOWTYPE.LIST);
        });
        break;
      case utils.POSTTRUCKSHOWTYPE.DETAIL_EDIT:
        this.props.updatePostTruck(postData).then((res) => {
          this.props.editData(res.data);
          this.props.changeShowCard(utils.POSTTRUCKSHOWTYPE.LIST);
        });
        break;
      default:
        break;
    }
  }
  togglePrompt() {
    this.setState({ showPrompt: !this.state.showPrompt });
  }
  openRateModal() {
    const originValue = this.address.origin || null;
    const destinationValue = this.address.destination || null;
    const _this = this;
    this.props.showRateModal({
      origin: originValue,
      destination: destinationValue,
      rate: this.state.rate,
      toggleFunc: () => this.togglePrompt.call(_this),
    });
  }
  multiDateSelect(type, date) {
    const frData = this.state.frequencyDate;
    const nowVal = frData[type];
    if (nowVal.indexOf(date) > -1) {
      nowVal.splice(nowVal.indexOf(date), 1);
    } else {
      nowVal.push(date);
    }
    frData[type] = nowVal;
    this.setState({ frequencyDate: frData });
  }
  toggleDrop(type, _this) {
    if (!this.state[`${type}Drop`]) {
      document.addEventListener("click", dropFunc[type]);
    } else {
      document.removeEventListener("click", dropFunc[type]);
    }
    const that = _this || this;
    that.setState({ [`${type}Drop`]: !that.state[`${type}Drop`] });
  }
  frequencyOneTimeChange(type, day) {
    const freData = this.state.frequencyDate;
    const nowDay = freData["One Time"][type];
    if (nowDay && nowDay.length > 0 && nowDay[0] === day[0]) return;
    freData["One Time"][type] = day;
    if (type === "from" && freData["One Time"].to[0]) {
      freData["One Time"].to =
        new Date(day) > new Date(freData["One Time"].to)
          ? day
          : freData["One Time"].to;
    }
    if (type === "to" && freData["One Time"].from[0]) {
      freData["One Time"].from =
        new Date(day) < new Date(freData["One Time"].from)
          ? day
          : freData["One Time"].from;
    }
    this.setState({
      frequencyDate: freData,
    });
  }
  weightItemSelect(item) {
    if (item === this.state.weight) return;
    this.setState({
      weight: item,
      weightInput: "",
    });
  }
  weightInputBlur(param) {
    const nowVal = param.target.value || "";
    if (this.state.weight === nowVal || !nowVal) return;
    this.setState({ weight: nowVal });
  }
  simpleDropdownFunc(type, selected) {
    let orgVal = this.state[type];
    let nextVal = Array.isArray(selected) ? selected.join("") : selected;
    if (orgVal === nextVal) return;

    if (type === "frequency") {
      this.setState({
        [type]: nextVal,
        frequencyError: { from: "", to: "", weekly: "", monthly: "" },
      });
      return;
    }
    this.setState({
      [type]: nextVal,
    });
  }
  checkRequire(type, val) {
    if (this.state.formError[type] === undefined) return;
    const errorMess = val
      ? ""
      : `${type[0].toUpperCase() + type.substring(1)} is required`;
    this.state.formError[type] = errorMess;
    this.setState({ formError: this.state.formError });
  }
  getPositiveNumber(val) {
    if (!val) return val;
    const inputArray = val.match(/\d/g);
    let inputVal = inputArray ? inputArray.join("") : "";
    return inputVal;
  }
  numberInputBlur(type, param, require) {
    let inputVal = this.getPositiveNumber(param.target.value);

    if (type.toLowerCase().includes("deadhead")) {
      inputVal = inputVal > 200 ? "200mi" : inputVal ? `${inputVal}mi` : "";
    }
    this.setState({
      [type]: inputVal,
    });

    if (require) this.checkRequire(type, inputVal);
  }
  numberInputChange(type, param) {
    let inputVal = this.getPositiveNumber(param.target.value);
    if (type.toLowerCase().includes("deadhead")) {
      inputVal = inputVal > 200 ? "200" : inputVal;
    }
    // inputVal = inputVal ? `${inputVal}mi` : "";
    this.setState({
      [type]: inputVal,
    });
  }
  addressBlur(param, type) {
    if (!param.data.placeValue || param.data.placeValue.name === undefined)
      return;
    const key = param.name;
    this.address[type] = param.data;
    const stateData = {
      [key]: this.state[key],
      formError: this.state.formError,
    };

    let errorStr = "";
    if (!param.data.placeValue.name || isEmpty(param.data.placeValue)) {
      errorStr = utils.ERRORMESS.empty;
    } else if (
      (param.data.placeValue.name.indexOf(",") === -1 &&
        !param.data.placeValue.is_city) ||
      param.data.placeValue.is_other
    ) {
      errorStr = utils.ERRORMESS.city;
    }

    stateData[key] = param.data.placeValue.name;
    stateData.formError[key] = errorStr;

    this.setState(stateData);
  }
}

const fields = [
  "origin",
  "orgDeadHead",
  "destination",
  "desDeadHead",
  "trailerType",
  "loadSize",
];

const reduxedForm = reduxForm(
  {
    form: "posttruck",
    id: "posttruck",
    fields,
  },
  (state, props) => ({
    anonBanerTextAndAction: config.anonBanerTextAndAction,
    initialValues: initForm(props.initData),
  })
)(detailForm);

export default connect(
  (props, ownProps) => {
    const { user, postTruck } = props;
    return {
      selectedPostTruck: postTruck.selectedPostTruck,
      rate: postTruck.rate,
      initData: postTruck.selectedPostTruck,
      showCard: postTruck.showCard,
      userId: user.id,
    };
  },
  mapDispatch({
    // onSubmit: (props, formData) => props.submit(formData),
    showRateModal: (props, myProps) =>
      modalChange(modes.POSTTRUCK_RATE, {
        type: "askPop",
        ...myProps,
      }),
    changeShowCard: (props, type) => changShowCardAction(type),
    createPostTruck: (props, createData) => createPostTuckAction(createData),
    updatePostTruck: (props, updateData) => updatePostTruckAction(updateData),
    addData: (props, addData) => addPostTruckAction(addData),
    editData: (props, editData) => editPostTruckAction(editData),
    setRate: (props, rate) => setRateAction(rate),
    initForm: (props, initData) => ininFormAction(initData),
  })
)(reduxedForm);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/compontents/DetailForm/index.js